import { useContext } from 'react';
import { InventoryAddProductFormContext } from '../../../Context/InventoryAddProductFormContext';
import Input from '../../../Components/Input/Input';

function ProductDetails() {
    const { productDetails, setProductDetails, formErrors } = useContext(InventoryAddProductFormContext);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setProductDetails({ ...productDetails, [name]: value });
    }

    return (
        <div className="flex flex-col gap-4 border border-[#EAEAEA] p-5 rounded-xl">
            <h1 className='font-semibold text-[18px] leading-[26px] select-none'>Product Details</h1>

            <Input 
                labelText='Product Name' 
                errorText={formErrors.productName} 
                inputOptions={{
                    type: 'text',
                    id: 'productName',
                    name: 'productName',
                    placeholder: 'Enter product name',
                    value: productDetails.productName,
                    onChange: handleChange
                }}
                required
            />

            <div className="flex flex-col gap-2">
                <label className='w-fit select-none cursor-pointer font-medium text-base text-[#121212]' htmlFor="productDescription">Product Description</label>

                <textarea 
                    className='outline-none h-72 px-3 py-4 bg-[#F5F5F5] border border-[#EAEAEA] rounded-[9px] font-normal text-base text-[#121212] focus:border-primaryColor'
                    name="productDescription" 
                    id="productDescription" 
                    placeholder='Write a short description about this category(Optional)' 
                    value={productDetails.productDescription} 
                    onChange={handleChange} 
                />
            </div>
        </div>
    );
}

export default ProductDetails;
